<template>
  <el-form-item
    :label="item.label"
    :prop="`${item.field}`"
    :hidden="item.options.hidden"
    v-if="item.showed"
    :rules="[
      {
        required: item.required || false,
        message: item.label + '为必填字段',
      },
    ]"
  >
    <div class="main">
      <a href="javascript:void(0)" @click="download(file.url, file.name)" v-for="(file, idx) of JSON.parse(item.val)" :key="idx">
        <div class="file-list-group">
          <div class="file-group-cell">
            <i class="el-icon-paperclip text-muted"></i>
          </div>
          <div class="file-group-cell">
            <span class="file-title">{{ file.name }}</span>
          </div>
        </div>
      </a>
    </div>
  </el-form-item>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  methods: {
    download(url, fileName) {
      const x = new window.XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
      };
      x.send();
    },
  },
};
</script>

<style lang="scss" scoped>
.file-list-group {
  display: table;
  .file-group-cell {
    display: table-cell;
    width: auto;
    padding: 0 12px;
    white-space: nowrap;
    vertical-align: middle;
    .text-muted {
      font-size: 18px;
    }
  }
  .file-group-cell:first-child {
    padding-right: 0;
    padding-left: 7px;
  }
}
</style>
